import React, { useState, useEffect } from "react";
import axiosInstance from "../axiosInstance"; // Import axiosInstance
import "./Form.css";
import { useLocation } from "react-router-dom";

const Contact = () => {
  const [formData, setFormData] = useState({
    cust_sr_no: "",
    cust_mob_no: "",
    cust_veh_no: "",
  });

  const [srNumbers, setSrNumbers] = useState([]); // Store multiple SR numbers
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const location = useLocation();
  const { vehicleNumber = "", srNumber = "" } = location?.state || {};

  const handleChange = (e) => {
    let error = "";
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "cust_mob_no") {
      const numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
      if (!numericValue.trim()) {
        error = "Enter your mobile number";
      } else if (numericValue.length !== 10) {
        error = "Mobile number must be exactly 10 digits.";
      }
      setFormData({ ...formData, [name]: numericValue.slice(0, 10) }); // Restrict to 10 digits
      setErrors({ ...errors, [name]: error });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // Handle search button click to fetch data
  // const handleSearch = async () => {
  //   if (!formData.cust_veh_no.trim()) {
  //     setErrors({ ...errors, cust_veh_no: "Enter your Registration number" });
  //     return;
  //   }

  //   const token = localStorage.getItem("token");
  //   if (!token) {
  //     alert("Authentication token is missing. Please log in.");
  //     return;
  //   }

  //   try {
  //     const response = await axiosInstance.post(
  //       "/pifir/get_vehicle_sr_details/",
  //       { registration_num: formData.cust_veh_no },
  //       {
  //         headers: { Authorization: `Bearer ${token}` },
  //       }
  //     );

  //     const data = response.data;
  //     if (!data.sr_number || data.sr_number.length === 0) {
  //       throw Error("No open SR found for this Registration Number.");
  //     }
  //     setSrNumbers(data.sr_number || []);
  //     setFormData({
  //       ...formData,
  //       cust_sr_no: data.sr_number.length >= 1 ? data.sr_number[0] : "",
  //       cust_mob_no: data.mobile_number,
  //     });

  //     setErrors({});
  //   } catch (error) {
  //     console.error("API Call Failed:", error);
  //     alert("No details found for this Registration Number.");
  //   }
  // };
const handleSearch = async () => {
  if (!formData.cust_veh_no.trim()) {
    setErrors({ ...errors, cust_veh_no: "Enter your Registration number" });
    return;
  }

  const token = localStorage.getItem("token");
  if (!token) {
    setSuccessMessage("Authentication token is missing. Please log in.");
    setShowPopup(true);
    return;
  }

  try {
    const response = await axiosInstance.post(
      "/pifir/get_vehicle_sr_details/",
      { registration_num: formData.cust_veh_no },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    const data = response.data;
    if (!data.sr_number || data.sr_number.length === 0) {
      setSuccessMessage("No open sr numbers are available against this number");
      setShowPopup(true);
      return;
    }

    setSrNumbers(data.sr_number || []);
    setFormData({
      ...formData,
      cust_sr_no: data.sr_number.length >= 1 ? data.sr_number[0] : "",
      cust_mob_no: data.mobile_number,
    });

    setErrors({});
  } catch (error) {
    console.error("API Call Failed:", error);
    if (error.response && error.response.status === 412) {
      setSuccessMessage("Data loading failed");
    } else {
      setSuccessMessage("No open sr numbers are available against this number");
    }
    setShowPopup(true);
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm(formData);
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      try {
        const response = await axiosInstance.post(
          "/pifir/sendlink/",
          {
            cust_sr_no: formData.cust_sr_no,
            cust_mob_no: formData.cust_mob_no,
            cust_veh_no: formData.cust_veh_no,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        setSuccessMessage(
          `Feedback link shared successfully to ${formData.cust_mob_no}`
        );
        setShowPopup(true);
      } catch (error) {
        console.error("API Error:", error.response.data.msg);
        alert(error.response.data.msg);
      }
    } else {
      console.log("Form submission failed due to validation errors.");
    }
  };

  const validateForm = (data) => {
    const errors = {};

    if (!data.cust_veh_no.trim()) {
      errors.cust_veh_no = "Enter your Registration number";
    }

    if (!data.cust_sr_no.trim()) {
      errors.cust_sr_no = "Select your SR number";
    }

    if (!data.cust_mob_no.trim() || data.cust_mob_no.length !== 10) {
      errors.cust_mob_no = "Enter your 10-digit mobile number";
    }

    return errors;
  };

  const closePopup = () => {
    setShowPopup(false);
    setSuccessMessage("");
  };
  useEffect(() => {
    if (vehicleNumber && srNumber) {
      setFormData({
        ...formData,
        cust_veh_no: vehicleNumber,
        cust_sr_no: srNumber,
      });
    }
  }, []);

  return (
    <div className="form-container">
      <h2 className="form-title">Provide Following Details:</h2>
      <p style={{ color: "red" }}>Used for SmartPhone Customer</p>

      <form onSubmit={handleSubmit} autoComplete="off">
        <div className="input-container">
          <label className="form-label">Customer Registration Number :</label>
          <div className="search-wrapper">
            <input
              className="form-input"
              type="text"
              name="cust_veh_no"
              value={formData.cust_veh_no}
              onChange={handleChange}
              disabled={!!vehicleNumber}
              autoComplete="off"
            />
            <button
              type="button"
              className="search-icon"
              onClick={handleSearch}
              disabled={!!vehicleNumber && !!srNumber}
            >
              Search
            </button>
          </div>
          {errors.cust_veh_no && (
            <span className="error-message">{errors.cust_veh_no}</span>
          )}
        </div>

        <div>
          <label className="form-label">Customer SR Number :</label>
          {srNumbers.length > 1 ? (
            <select
              className="form-input"
              name="cust_sr_no"
              value={formData.cust_sr_no}
              onChange={handleChange}
            >
              {srNumbers.map((sr, index) => (
                <option key={index} value={sr}>
                  {sr}
                </option>
              ))}
            </select>
          ) : (
            <input
              className="form-input"
              type="text"
              name="cust_sr_no"
              value={formData.cust_sr_no}
              readOnly
            />
          )}
          {errors.cust_sr_no && (
            <span className="error-message">{errors.cust_sr_no}</span>
          )}
        </div>

        <div>
          <label className="form-label">Customer Mobile Number :</label>
          <input
            className="form-input"
            type="text"
            name="cust_mob_no"
            value={formData.cust_mob_no}
            onChange={handleChange}
            autoComplete="off"
          />

          {errors.cust_mob_no && (
            <span className="error-message">{errors.cust_mob_no}</span>
          )}
        </div>

        <button className="submit-button" type="submit">
          Submit
        </button>
      </form>

      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <p>{successMessage}</p>
            <button onClick={closePopup} className="close-popup-btn">
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Contact;
